import React from "react";
import { CheckCircle } from "lucide-react";

const whatsappLeadsData = [
  {
    heading: "Send Invites That Get Responses",
    points: [
      "Reach attendees instantly with WhatsApp invites.",
      "Add RSVP links for one-tap sign-ups.",
      "Share event details like time and location in a snap.",
      "Get 98% open rates—way better than email’s 20%.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/event_and_webinar/event_and_webinar_2.png",
  },
  {
    heading: "Never Miss a Beat with Reminders",
    points: [
      "Send auto-reminders a day or hour before your event.",
      "Cut no-shows with timely WhatsApp nudges.",
      "Keep attendees excited and informed.",
      "Save time—no manual follow-ups needed.",
    ],
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/event_and_webinar/event_and_webinar_3.png",
  },
  {
    heading: "Share Schedules They’ll Actually Read",
    points: [
      "Send event agendas and speaker lists via WhatsApp.",
      "Keep everything in one easy-to-find spot.",
      "Help attendees plan their day with clear info.",
      "Boost participation with organized updates.",
    ],
    buttonText: "Meta Policy for Webinar",
    buttonLink:"https://www.facebook.com/business/help/488043719226449?id=434838534925385",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/event_and_webinar/event_and_webinar_4.png",
  },
  {
    heading: "Take Payments Right on WhatsApp",
    points: [
      "Let attendees pay for tickets without leaving the chat.",
      "Make it quick and secure with built-in payment links.",
      "Sell more seats with a smooth checkout process.",
      "Track payments easily with ChatMitra’s tools.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/event_and_webinar/event_and_webinar_5.png",
  },
  {
    heading: "Get Feedback That Makes a Difference",
    points: [
      "Ask for post-event thoughts via WhatsApp.",
      "Find out what worked and what didn’t.",
      "Use insights to make your next event even better.",
      "Show attendees you value their input.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/event_and_webinar/event_and_webinar_6.png",
  },
];

const Eventcycle = () => {
  return (
    <>
      <div className="flex flex-col justify-center items-center text-center h-52 sm:h-64 md:h-72 lg:h-80 px-6 py-4 bg-gradient-to-r from-green-200 via-green-300 to-green-400 shadow-lg rounded-lg">
        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold leading-tight max-w-4xl text-gray-900">
          Run Better Events with WhatsApp for Events
        </h1>
        <div className="w-16 h-1 bg-gray-600 my-4 rounded-full"></div>
        <p className="text-sm sm:text-lg md:text-xl text-gray-800 max-w-3xl mt-2 md:mt-4 px-2">
          ChatMitra helps event planners pack seats, cut hassles, and wow attendees with WhatsApp automation.
        </p>
      </div>
      <div className="flex flex-col gap-20 sm:gap-20 bg-white max-w-6xl mx-auto mt-10 mb-10 px-4 sm:px-0">
        {whatsappLeadsData.map((item, index) => (
          <section
            key={index}
            className={`flex flex-col md:flex-col lg:flex-row items-center justify-between gap-16 sm:gap-20 ${
              index % 2 === 1 ? "lg:flex-row-reverse" : ""
            }`}
          >
            <div className="lg:w-1/2 md:w-full flex justify-center mb-4 lg:mb-0">
              <img
                src={item.image}
                alt={`${item.heading} with ChatMitra`}
                className="max-w-full h-auto rounded-lg border-transparent transition-all duration-500"
              />
            </div>
            <div className="w-full md:w-full lg:w-1/2 text-left md:p-5">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 leading-tight">{item.heading}</h2>
              <ul className="mt-6 space-y-4 text-lg text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start space-x-3">
                    <CheckCircle className="text-[#075E54] w-4 h-4 self-center flex-shrink-0" strokeWidth={3} />
                    <span className="leading-relaxed">{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
               <a
               href={item.buttonLink}
               className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
             >
               {item.buttonText}
             </a>
              )}
            </div>
          </section>
        ))}
      </div>
    </>
  );
};

export default Eventcycle;